import React from "react";
import { Avatar, Box, Grid, Icon, styled, Typography } from "@mui/material";
import CardData from "../../shared/dashboard/CardData";
import Utils from "../../../../utils";
import ChartAreaCustom from "../../shared/dashboard/ChartArea";
import dayjs from "dayjs";
import CardDashboard from "../../shared/dashboard/CardDashboard";
import { useSelector } from "react-redux";
import ChartDonutCustom from "../../shared/dashboard/ChartDonut";

const StyledRoot = styled(Box)({
  "& .top-employee": {
    padding: "8px",
    // paddingTop: "16px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ececec",
    borderRadius: "4px"
  }
})

const WorkingtimePanel = (props) => {

  const { month, year, realEmployee, realWorkingTime, empLoading, leaveByType } = props;
  const lvType = (leaveByType || []).slice(0, 8); // โดนัทการลาแยกประเภท

  const {result: dashboardWorkingtime} = useSelector(state => state.dashboardWorkingtime);

  const rw = realWorkingTime;
  const info = dashboardWorkingtime.workingTimeEmployeeInfo;
  const top5Absent = rw
    ? rw.top5Absent.map((r) => ({ ...r, value: r.absent, unit: "วัน" }))
    : [];
  const top5Late = rw
    ? rw.top5Late.map((r) => ({ ...r, value: r.late, unit: "ครั้ง" }))
    : [];

  return (
    <StyledRoot>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={8}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CardData 
                    title="พนักงาน"
                    loading={empLoading && !realEmployee}
                    dataValue={Utils.numberWithCommasWithoutDot(realEmployee ? realEmployee.employeeTotal : dashboardWorkingtime.employeeTotal)}
                    dataUnit="คน"
                    dynamicFontSize
                    titleIcon={
                      <Icon baseClassName="fal" className="fa-users" color="primary" style={{display: "inline-table" }}/>
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardData
                    title="ขาดงาน"
                    loading={!rw}
                    dataValue={rw ? Utils.numberWithCommasWithoutDot(rw.absentTotal) : "0"}
                    dataUnit="วัน"
                    dynamicFontSize
                    titleIcon={
                      <Icon baseClassName="fal" className="fa-calendar-xmark" color="error" style={{display: "inline-table" }}/>
                    }
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardData
                    title="มาสาย"
                    loading={!rw}
                    dataValue={rw ? Utils.numberWithCommasWithoutDot(rw.lateTotal) : "0"}
                    dataUnit="ครั้ง"
                    dynamicFontSize
                    titleIcon={
                      <Icon baseClassName="fal" className="fa-alarm-clock" color="primary" style={{display: "inline-table", color: "#ffcd38" }}/>
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={4}>
              <CardData
                title="ลางาน"
                loading={!rw}
                dataValue={rw ? Utils.numberWithCommasWithoutDot(rw.leaveTotal) : "0"}
                dataUnit="วัน"
                dynamicFontSize
                titleIcon={
                  <Icon baseClassName="fal" className="fa-memo" color="primary" style={{display: "inline-table" }}/>
                }
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <CardDashboard>
                <Typography marginBottom="16px">5 อันดับขาดงานสูงสุด</Typography>
                {top5Absent.length > 0 && (
                  <Box style={{display: "flex", gap: "16px", flexDirection: "column"}}>
                    {top5Absent.map((e, index) => (
                      <Box key={index} className="top-employee">
                        <Icon className={`fa-solid fa-square-${index+1}`} color="primary" style={{display: "inline-table", color: index <= 2? "#ffcd38": undefined}}/>
                        <Box style={{flexGrow: "1", display: "flex", alignItems: "center"}}>
                          <Avatar src={e.imageProfile} style={{marginRight: "8px", width: "32px", height: "32px"}}/>
                          <Typography>{e.firstname} {e.lastname}</Typography>
                        </Box>
                        <Typography>{Utils.numberWithCommasWithoutDot(e.value)} {e.unit}</Typography>
                      </Box>
                    ))}
                  </Box>
                )}
                {top5Absent.length <= 0 && (
                  <Typography textAlign="center" color="text.third">ไม่มีพนักงานขาดงาน</Typography>
                )}
              </CardDashboard>
            </Grid>

            <Grid item xs={12} lg={6}>
              <CardDashboard>
                <Typography marginBottom="16px">5 อันดับมาสายสูงสุด</Typography>
                {top5Late.length > 0 && (
                  <Box style={{display: "flex", gap: "16px", flexDirection: "column"}}>
                    {top5Late.map((e, index) => (
                      <Box key={index} className="top-employee">
                        <Icon className={`fa-solid fa-square-${index+1}`} color="primary" style={{display: "inline-table", color: index <= 2? "#ffcd38": undefined}}/>
                        <Box style={{flexGrow: "1", display: "flex", alignItems: "center"}}>
                          <Avatar src={e.imageProfile} style={{marginRight: "8px", width: "32px", height: "32px"}}/>
                          <Typography>{e.firstname} {e.lastname}</Typography>
                        </Box>
                        <Typography>{Utils.numberWithCommasWithoutDot(e.value)} {e.unit}</Typography>
                      </Box>
                    ))}
                  </Box>
                )}
                {top5Late.length <= 0 && (
                  <Typography textAlign="center" color="text.third">ไม่มีพนักงานมาสาย</Typography>
                )}
              </CardDashboard>
            </Grid>

          </Grid>
        </Grid>

        {/* โดนัทการลาแยกประเภท (ข้อมูลจริงจาก leave report) */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CardDashboard>
                <Typography marginBottom="16px">การลาแยกตามประเภท</Typography>
                {lvType.length > 0 ? (
                  <ChartDonutCustom
                    series={lvType.map((d) => Number(d.value) || 0)}
                    labels={lvType.map((d) => d.name || "อื่นๆ")}
                  />
                ) : (
                  <Typography textAlign="center" color="text.third" padding="24px">ไม่มีการลาในเดือนนี้</Typography>
                )}
              </CardDashboard>
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    </StyledRoot>
  )
}

export default WorkingtimePanel;